import {useContainerBreakpoint} from "@project/layouts";
import {routes} from "@project/router";
import {Navigate, createFileRoute, useParams} from "@tanstack/react-router";
import {useRef} from "react";

import {Route as RepresentativeRoute} from "./route";

export const Route = createFileRoute("/_app/sales/representatives/$representativeId/")({
  component: IndexRouteComponent,
});

function IndexRouteComponent() {
  const {representativeId} = useParams({strict: false}) as {representativeId: string};
  const {includeDeleted} = RepresentativeRoute.useSearch();
  const ref = useRef<HTMLDivElement>(null);
  const isDesktop = useContainerBreakpoint(ref);

  if (isDesktop) {
    return (
      <Navigate
        replace
        params={{representativeId}}
        search={{
          includeDeleted,
          page: 1,
          perPage: 10,
          q: undefined,
          sortBy: "editedAt",
          sortDir: "desc",
        }}
        to={routes.sales.representatives.representative().contacts()}
      />
    );
  }

  return <div ref={ref} className="h-full w-full" />;
}
